/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportForDeviceResponseUpgradeRuleHistoryElements,
    ReportForDeviceResponseUpgradeRuleHistoryElementsFromJSON,
    ReportForDeviceResponseUpgradeRuleHistoryElementsFromJSONTyped,
    ReportForDeviceResponseUpgradeRuleHistoryElementsToJSON,
} from './ReportForDeviceResponseUpgradeRuleHistoryElements';

/**
 * 
 * @export
 * @interface ReportForDeviceResponseUpgradeRuleHistory
 */
export interface ReportForDeviceResponseUpgradeRuleHistory {
    /**
     * 
     * @type {Array<ReportForDeviceResponseUpgradeRuleHistoryElements>}
     * @memberof ReportForDeviceResponseUpgradeRuleHistory
     */
    elements: Array<ReportForDeviceResponseUpgradeRuleHistoryElements>;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeviceResponseUpgradeRuleHistory
     */
    totalElementCount: number | null;
}

export function ReportForDeviceResponseUpgradeRuleHistoryFromJSON(json: any): ReportForDeviceResponseUpgradeRuleHistory {
    return ReportForDeviceResponseUpgradeRuleHistoryFromJSONTyped(json, false);
}

export function ReportForDeviceResponseUpgradeRuleHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceResponseUpgradeRuleHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': ((json['elements'] as Array<any>).map(ReportForDeviceResponseUpgradeRuleHistoryElementsFromJSON)),
        'totalElementCount': json['totalElementCount'],
    };
}

export function ReportForDeviceResponseUpgradeRuleHistoryToJSON(value?: ReportForDeviceResponseUpgradeRuleHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': ((value.elements as Array<any>).map(ReportForDeviceResponseUpgradeRuleHistoryElementsToJSON)),
        'totalElementCount': value.totalElementCount,
    };
}

